interface CardStyle {
  bg: string
  label: string
  value: string
}

const NEUTRAL: CardStyle = {
  bg: "bg-surface-1 border border-coval-border",
  label: "text-sm text-coval-text-muted font-medium mb-1",
  value: "text-xl font-bold text-coval-text-muted",
}

const TINTED: CardStyle = {
  bg: "bg-indigo-50 border border-indigo-200 dark:bg-indigo-900/20 dark:border-indigo-800",
  label: "text-sm text-indigo-600 font-medium mb-1 dark:text-indigo-400",
  value: "text-xl font-bold text-indigo-900 dark:text-indigo-100",
}

const DEFAULT_THRESHOLD = 0

/**
 * Returns card styling based on a metric value exceeding a threshold.
 * Pass a custom threshold to override the default (> 0).
 */
function getCardStyle(
  value: number,
  threshold: number = DEFAULT_THRESHOLD,
): CardStyle {
  return value > threshold ? TINTED : NEUTRAL
}

export { getCardStyle }
